import { MapTooltipProperty } from '@water-loss//features/map/map-tooltip/models/map-tooltip-property';

export class LayerItem {
  name: string;
  nativeLayer: any;
  pane: string;
  layerStyles: LayerStyle;
  tooltipProperties: MapTooltipProperty[];
  layerType: LayerTypeEnum;
  namespace: string;
  namespaceTitle: string;
  layerInfo: LayerInfo;
  getDynamicStyles;

  constructor(init: Partial<LayerItem>) {
    Object.assign(this, init);
  }
}

export class LayerStyle {
  zIndex: number;

  constructor(init: Partial<LayerStyle>) {
    Object.assign(this, init);
  }
}

export class LayerGroup {
  namespace: string;
  layers: LayerItem[];
  position: number;
  layerGroupTitle: string;

  constructor(init: Partial<LayerGroup>) {
    Object.assign(this, init);
  }
}

export enum LayerTypeEnum {
  NonTiledLayer = 'NonTiledLayer',
  TemporalLayer = 'TemporalLayer',
}

export enum LayerInfoTypeEnum {
  Topology = 'Topology',
  Thematic = 'Thematic',
}

export enum LayerElementTypeEnum {
  Pipe = 'Pipe',
  Node = 'Node',
  Heatmap = 'Heatmap',
}

export class LayerInfo {
  layerType: LayerInfoTypeEnum;
  elementType: LayerElementTypeEnum;

  constructor(init: Partial<LayerInfo>) {
    Object.assign(this, init);
  }
}
